<template>
    <div id="myModal" class="modal">
        <span class="close">&times;</span>
        <div id="modal-content">
            <center>
                <div class="row">
                    <div class="col-sm-3">
                        &nbsp;
                    </div>
                    <div class="col-sm-6">
                        <h1>
                            <span v-if="(bahasa === null) || (bahasa == 'ina')">PROGRES ADUAN</span>
                            <span v-else>COMPLAINT PROGRESS</span>
                        </h1>
                        <template v-for="(datalist, urutlist) in master" :key="urutlist">
                            <ol class="olcards">
                                <li :style="'--cardColor:' + datalist.colorditerima">
                                    <div class="content">
                                        <div class="icon"><i class="fas fa-angle-double-down"></i></div>
                                        <div class="title"><span
                                                v-if="(bahasa === null) || (bahasa == 'ina')">Diterima</span>
                                            <span v-else>Accepted</span>
                                        </div>
                                        <div class="text" style="width: 100%;font-size: smaller !important;">
                                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                Tanggal Aduan: {{ G_formatDate(datalist.createddate) }}<br>
                                                Nama: {{ datalist.nama }}<br>
                                                Alamat email: {{ datalist.alamat }}<br>
                                                Kategori: {{ datalist.jenis }}<br>
                                                Aduan:<div class="my-container" v-html="datalist.aduan"></div>
                                            </span>
                                            <span v-else>
                                                Complaint Date: {{ G_formatDate(datalist.createddate) }}<br>
                                                Name: {{ datalist.nama }}<br>
                                                Email: {{ datalist.alamat }}<br>
                                                Category: {{ datalist.jenis }}<br>
                                                Complaint: <span v-html="datalist.aduan"></span><br>
                                            </span>
                                            <span :style="'color:' + datalist.colorditerima">
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            </span>
                                        </div>
                                    </div>
                                </li>
                                <li :style="'--cardColor:' + datalist.colordiproses">
                                    <div class="content">
                                        <div class="icon"><i class="fas fa-angle-double-down"></i></div>
                                        <div class="title"><span
                                                v-if="(bahasa === null) || (bahasa == 'ina')">Diproses</span>
                                            <span v-else>Processed</span>
                                        </div>
                                        <div class="text" style="width: 100%;font-size: smaller !important;">
                                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                Tanggal Proses: {{ G_formatDateNonWIB(datalist.prosesdate) }}<br>
                                            </span>
                                            <span v-else>
                                                Processed Date: {{ G_formatDateNonWIB(datalist.prosesdate) }}<br>
                                            </span>
                                            <span :style="'color:' + datalist.colordiproses">
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            </span>
                                        </div>
                                    </div>
                                </li>
                                <li :style="'--cardColor:' + datalist.colorditindaklanjuti">
                                    <div class="content">
                                        <div class="icon"><i class="fas fa-angle-double-down"></i></div>
                                        <div class="title"><span
                                                v-if="(bahasa === null) || (bahasa == 'ina')">Ditindaklanjuti</span>
                                            <span v-else>Follow-up</span>
                                        </div>
                                        <div class="text" style="width: 100%;font-size: smaller !important;">
                                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                Tanggal Ditindaklanjuti: {{
                                                    G_formatDateNonWIB(datalist.tindaklanjutdate) }}<br>
                                            </span>
                                            <span v-else>
                                                Follow-up Date: {{ G_formatDateNonWIB(datalist.tindaklanjutdate) }}<br>
                                            </span>
                                            <span :style="'color:' + datalist.colorditindaklanjuti">
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            </span>
                                        </div>
                                    </div>
                                </li>
                                <li :style="'--cardColor:' + datalist.colorselesai">
                                    <div class="content">
                                        <div class="icon"><i class="fas fa-angle-double-down"></i></div>
                                        <div class="title"><span
                                                v-if="(bahasa === null) || (bahasa == 'ina')">Selesai</span>
                                            <span v-else>Finished</span>
                                        </div>
                                        <div class="text" style="width: 100%;font-size: smaller !important;">
                                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                Tanggal Selesai: {{ G_formatDateNonWIB(datalist.finishdate) }}<br>
                                                Hasil: <span v-html="datalist.tindaklanjut"></span>
                                            </span>
                                            <span v-else>
                                                Finished Date: {{ G_formatDateNonWIB(datalist.finishdate) }}<br>
                                                Result: <span v-html="datalist.tindaklanjut"></span>
                                            </span>
                                            <span :style="'color:' + datalist.colorselesai">
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            </span>
                                        </div>
                                    </div>
                                </li>
                            </ol>
                        </template>
                    </div>
                    <div class="col-sm-3">
                        &nbsp;
                    </div>
                </div>
            </center>
        </div>
    </div>
    <Top />
    <!-- Spinner Start -->
    <!-- Spinner Start -->
    <div id="spinner" style="background-color: #DCDCDC;z-index: 999999;opacity: 0.5;" v-if="halamanloading"
        class="show position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center">
        <img src="../../../../src/assets/images/logo.png" height="40">&nbsp;
        <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
        </div>
        &nbsp;<span class="sr-only text-danger" style="font-weight: bolder;">..CISP System Loading...</span>
    </div>
    <!-- Spinner End -->
    <section class="hero-section d-flex justify-content-center align-items-center" id="section_1"
        :style="'background-image:url(' + folder_slider + foto_background + ') !important;'">
        <div class="section-overlay"></div>
        <svg xmlns="" viewBox="0 5 1440 320">
            <rect x="0" y="0" width="2980" height="100" fill="#3D405B" />
        </svg>
        <div class="container">
            <div class="row">
                <div class="col-lg-12 col-12 mb-5 mb-lg-0">
                    <h5 class="text-white">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">{{ namaku }}&nbsp;</span>
                        <span v-else>{{ nama_eng }}&nbsp;</span>
                    </h5>
                    <h1 class="cd-headline rotate-1 text-white mb-4 pb-2">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">{{ text_label }}&nbsp;</span>
                        <span v-else>{{ text_label_eng }}&nbsp;</span>
                        <span v-if="(bahasa === null) || (bahasa == 'ina')" class="cd-words-wrapper">
                            <template v-for="(dataketerangan, urutketerangan) in keterangan" :key="urutketerangan">
                                <b :class="[((urutketerangan == 0) ? 'is-visible' : '')]">{{ dataketerangan.nama }}</b>
                            </template>
                        </span>
                        <span v-else class="cd-words-wrapper">
                            <template v-for="(dataketerangan_eng, urutketerangan_eng) in keterangan_eng"
                                :key="urutketerangan_eng">
                                <b :class="[((urutketerangan_eng == 0) ? 'is-visible' : '')]">{{ dataketerangan_eng.nama
                                    }}</b>
                            </template>
                        </span>
                    </h1>
                </div>
            </div>
        </div>

        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
            <path fill="#ffffff" fill-opacity="1"
                d="M0,224L34.3,192C68.6,160,137,96,206,90.7C274.3,85,343,139,411,144C480,149,549,107,617,122.7C685.7,139,754,213,823,240C891.4,267,960,245,1029,224C1097.1,203,1166,181,1234,160C1302.9,139,1371,117,1406,106.7L1440,96L1440,320L1405.7,320C1371.4,320,1303,320,1234,320C1165.7,320,1097,320,1029,320C960,320,891,320,823,320C754.3,320,686,320,617,320C548.6,320,480,320,411,320C342.9,320,274,320,206,320C137.1,320,69,320,34,320L0,320Z">
            </path>
        </svg>
    </section>
    <section class="about-section">
        <div class="container">
            <div class="row">
                <div class="col-lg-12 col-12 me-auto mb-4 mb-lg-0 text-center">
                    &nbsp;
                </div>
                <div class="col-lg-12 col-12 me-auto mb-4 mb-lg-0 text-center">
                    <h5 v-if="(bahasa === null) || (bahasa == 'ina')">
                        Silahkan masukkan kode register yang dipunyai<br><br>
                    </h5>
                    <h5 v-else>
                        Please enter the registration code you have<br><br>
                    </h5>
                </div>
                <div class="row">
                    <div class="col-sm-12 float-left pb-2 wow fadeInDown">
                        <label v-if="(bahasa === null) || (bahasa == 'ina')">Kode Register</label>
                        <label v-else>Register Code</label>
                        <div class="input-group mb-3">
                            <div class="input-group-prepend">
                                <span class="input-group-text"><i class="fas fa-user-circle"></i></span>
                            </div>
                            <input type="text" class="form-control form-control-sm" id="register" name="register"
                                placeholder="Kode Register / Register Code" v-model="register">
                        </div>
                    </div>
                    <div class="col-sm-6 float-left pb-2 wow fadeInDown">
                        <label v-if="(bahasa === null) || (bahasa == 'ina')">Kode Keamanan</label>
                        <label v-else>Captcha</label>
                        <div class="input-group mb-3">
                            <div class="input-group-prepend">
                                <span class="input-group-text"><i class="fas fa-clipboard-list"></i></span>
                            </div>
                            <input type="text" class="form-control form-control-sm" id="capchacari" name="capchacari"
                                placeholder="" v-model="capchacari" disabled>
                        </div>
                    </div>
                    <div class="col-sm-6 float-left pb-2 wow fadeInDown">
                        <label v-if="(bahasa === null) || (bahasa == 'ina')">Ulangi Kode Keamanan</label>
                        <label v-else>Repeat Captcha</label>
                        <div class="input-group mb-3">
                            <div class="input-group-prepend">
                                <span class="input-group-text"><i class="far fa-clone"></i></span>
                            </div>
                            <input type="text" class="form-control form-control-sm" id="capchainputcari"
                                name="capchainputcari" placeholder="" v-model="capchainputcari"
                                style="text-transform:uppercase">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="lockscreen-item wow fadeInLeft" style="background: transparent;">
            <div class="input-group">
                <div class="custom-control custom-switch custom-switch-on-primary">
                    <input type="checkbox" class="custom-control-input" id="customSwitchAuthcari">
                    <label class="custom-control-label" for="customSwitchAuthcari" @click="rubahisicari()"
                        style="font-size: small;">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">Autentikasi Pengguna Manusia</span>
                        <span v-else>Human User Authentication</span>
                    </label>
                </div>
            </div>
            <div class="help-block text-center">&nbsp;</div>
            <button class="form-control btn custom-btn" placeholder="Kirim" data-toggle="tooltip" data-placement="left"
                title="Kirim aduan.." style="color: black;" v-on:click="cariaduanAct" :disabled="showHumancari == false"
                v-if="(bahasa === null) || (bahasa == 'ina')">
                <b><i class="fas fa-search"></i>
                    Cari
                </b>
            </button>
            <button class="form-control btn custom-btn" placeholder="Kirim" data-toggle="tooltip" data-placement="left"
                title="Kirim aduan.." style="color: black;" v-on:click="cariaduanAct" :disabled="showHumancari == false"
                v-else>
                <b><i class="fas fa-search"></i>
                    Search
                </b>
            </button>
        </div>
    </section>
    <a href="#" class="btn btn-dangerbulet btn-lg-square back-to-top text-white"><i class="fa fa-arrow-up"></i></a>
    <Footer />
</template>

<script>
import axios from 'axios';
import $ from 'jquery';
import swal from 'sweetalert2';
import CryptoJS from 'crypto-js';
import 'vue3-carousel/dist/carousel.css'
import VueApexCharts from "vue3-apexcharts";
import { quillEditor } from 'vue3-quill';
window.Apex.chart = { fontFamily: "Poppins-SemiBold, Arial, sans-serif" };
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel'

import Top from "./Template/Top.vue";
import Footer from "./Template/Footer.vue";

export default {
    components: {
        Top, Footer, swal, quillEditor
    },
    data() {
        return {
            halamanloading: true,
            tabaktif: encodeURIComponent(CryptoJS.AES.encrypt('', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString()),
            datapesan: '',
            datamaster: [],
            tahun: new Date().getFullYear(),
            folder_foto: process.env.VUE_APP_URL_API + 'parastapainnovation_beranda-Gambar?f=',
            project_id: process.env.VUE_APP_PROJECT_ID,
            nama: '',
            register: '',
            capchacari: this.makeid(5), capchainputcari: "",
            showHumancari: false,
            project_id: process.env.VUE_APP_PROJECT_ID,
            master: [],
            bahasa: localStorage.getItem("bahasasistem"),
            namaku: '',
            nama_eng: '',
            text_label: '',
            text_label_eng: '',
            keterangan: [],
            keterangan_eng: [],
            folder_slider: process.env.VUE_APP_URL_API + 'parastapainnovation_slider-Gambar?f=',
            foto_background: '',
        };
    },
    methods: {
        rubahisicari() {
            if (this.showHumancari == false) {
                this.showHumancari = true;
            }
            else {
                this.showHumancari = false;
            }
        },
        async cariaduanAct() {
            //alert(this.aduan);
            if ((this.register == "") || (this.register == "")) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon isikan salah satu kolom ..',
                });
                document.getElementById('customSwitchAuthcari').checked = false;
                document.getElementById("nama").focus();
                this.showHuman = false;
                document.getElementById('customSwitchAuthcari').checked = false;
                return false;
            }

            if (this.capchainputcari == "") {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Isikan kolom secara lengkap..',
                });
                document.getElementById('customSwitchAuthcari').checked = false;
                document.getElementById("capchainputcari").focus();
                this.showHuman = false;
                document.getElementById('customSwitchAuthcari').checked = false;
                return false;
            }
            if (this.capchainputcari.toUpperCase() != this.capchacari) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Kode Keamanan Tidak Sama..',
                });
                document.getElementById('customSwitchAuthcari').checked = false;
                document.getElementById("capchainputcari").focus();
                this.showHumancari = false;
                document.getElementById('customSwitchAuthcari').checked = false;
                return false;
            }

            const data = {
                project_id: this.project_id,
                register: this.register,
            };

            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            });
            await mainAPI.post("parastapainnovationMasyarakat-cari", data).then(
                Response => {
                    if (Response.data.response == 'error') {
                        swal.mixin({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 3000
                        }).fire({
                            icon: 'warning',
                            title: Response.data.message,
                        });
                        //document.getElementById("nama").focus();
                        this.showHumancari = false;
                        this.capchacari = this.makeid(5);
                        this.capchainputcari = "";
                        document.getElementById('customSwitchAuthcari').checked = false;
                        return false;

                    }
                    else {
                        //alert('berhasil');
                        this.master = [];
                        this.master = Response.data.content.data;
                        var modal = document.getElementById("myModal");
                        // Get the image and insert it inside the modal - use its "alt" text as a caption
                        //var img = document.getElementById(id);
                        modal.style.display = "block";

                        // Get the <span> element that closes the modal
                        var span = document.getElementsByClassName("close")[0];

                        // When the user clicks on <span> (x), close the modal
                        span.onclick = function () {
                            modal.style.display = "none";
                        }
                        this.showHumancari = false;
                        this.capchacari = this.makeid(5);
                        this.capchainputcari = "";
                        document.getElementById('customSwitchAuthcari').checked = false;

                        return false;
                    }
                }
            ).catch(
                error => {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: error,
                    });
                    document.getElementById("register").focus();
                    document.getElementById('customSwitchAuthcari').checked = false;
                    this.showHumancari = false;
                    return false;
                }
            )
        },
        async ambildata() {
            const mainAPI3 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });

            this.halamanloading = true;
            var random = Math.random();
            await mainAPI3.get("parastapainnovation-GetSlider?random=" + random + "&project_id=" + this.project_id + "&id=8").then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.dataslider = [];
                        this.dataslider = Response.data.content.data;
                        this.namaku = Response.data.content.data[0].nama;
                        this.nama_eng = Response.data.content.data[0].nama_eng;
                        this.text_label = Response.data.content.data[0].text_label;
                        this.text_label_eng = Response.data.content.data[0].text_label_eng;
                        this.keterangan = Response.data.content.data[0].keterangan;
                        this.keterangan_eng = Response.data.content.data[0].keterangan_eng;
                        this.foto_background = '';
                        this.foto_background = Response.data.content.data[0].filenya_slider;
                        this.halamanloading = false;
                    }
                    else {
                        this.dataslider = [];
                        this.foto_background = '';
                        this.halamanloading = false;
                    }
                }
            ).catch(error => {
                this.datapesan = '';
                this.foto_background = '';
                this.dataslider = [];
                this.halamanloading = false;
            });
        },
    },
    mounted() {
        this.ambildata();
    },
}
</script>

<style>
.carousel__prev,
.carousel__next {
    box-sizing: content-box;
    border: 5px solid #0055aa;
    border-radius: 40px;
    background-color: #0055aa;
    color: aliceblue;
    height: 50px;
    width: 50px;
}

/* The Modal (background) */
.modal {
    display: none;
    /* Hidden by default */
    position: fixed;
    /* Stay in place */
    z-index: 888888;
    /* Sit on top */
    padding-top: 20px;
    /* Location of the box */
    left: 0;
    top: 0;
    width: 100%;
    /* Full width */
    height: 100%;
    /* Full height */
    overflow: auto;
    /* Enable scroll if needed */
    background-color: rgb(251, 248, 248, 0.9);
    /* Fallback color */
    background-color: rgb(251, 248, 248, 0.9);
    /* Black w/ opacity */
}

/* Modal Content (image) */
.modal-content {
    margin: auto;
    display: block;
    width: 80%;
    max-width: 700px;
    float: left;
    margin-right: 10px;
    margin-left: 60px;
}

/* Caption of Modal Image */
#caption {
    margin: auto;
    display: block;
    width: 90%;
    max-width: 90%;
    text-align: justify;
    color: #111;
    padding: 10px 0;
}

/* Add Animation */
.modal-content,
#caption {
    -webkit-animation-name: zoom;
    -webkit-animation-duration: 0.6s;
    animation-name: zoom;
    animation-duration: 0.6s;
}

@-webkit-keyframes zoom {
    from {
        -webkit-transform: scale(0)
    }

    to {
        -webkit-transform: scale(1)
    }
}

@keyframes zoom {
    from {
        transform: scale(0)
    }

    to {
        transform: scale(1)
    }
}

/* The Close Button */
.close {
    position: absolute;
    top: 20px;
    right: 35px;
    color: #111;
    font-size: 40px;
    font-weight: bold;
    transition: 0.3s;
    z-index: 99999;
}

.close:hover,
.close:focus {
    color: #111;
    text-decoration: none;
    cursor: pointer;
}

/* 100% Image Width on Smaller Screens */
@media only screen and (max-width: 700px) {
    .modal-content {
        width: 100%;
    }
}

.gambar:hover {
    cursor: pointer;
    opacity: 0.5;
}

.my-container h1 {
    color: green;
    font-size: smaller !important;
}

.my-container p {
    color: white;
    font-size: small !important;
}
</style>